module.exports = __webpack_public_path__ + "static/nav-banner-car@2x-281955a8dba7394d16b13b5293bc6ba0.png";